import { ROOT_PATH } from "../../../../../../routes/constants";
import { AGENT_PROFILE_BASE_PATH } from "../../../../../agent-profile/constants";
export const PROFILE_URL_DETAIL = `${ROOT_PATH}${AGENT_PROFILE_BASE_PATH}`;
